<template>
	<page>
		<module enable-flex>
			<m-search ref="search" :default-data="defaultSearchData" @search="searchHandle">
				<m-search-item label="统计月份">
					<c-datetime name="month" type="date" format="yyyy-MM" :clear="false"></c-datetime>
				</m-search-item>
				<m-search-item label="所属网点">
					<c-select name="outlet_id" async @search="searchOutlet"></c-select>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button v-if="auth('b_attendance_analysis_export')" prepend-icon="tf-export" @click="exportHandle">导出</c-button>
			</m-operate>

			<c-table v-if="days.length" ref="list" border height="grow" :paging="false" class="attendance-table">
				<c-table-column label="姓名" width="80" fixed="left" :row-span="({data}) => data.rowspan">
					<template #default="{data}">
						{{data.engineer_name}}
					</template>
				</c-table-column>
				<c-table-column label="网点" width="80" fixed="left" :row-span="({data}) => data.rowspan">
					<template #default="{data}">
						{{data.outlet_name}}
					</template>
				</c-table-column>
				<c-table-column label="类型" width="55" fixed="left">
					<template #default="{data}">
						{{data.type_name}}
					</template>
				</c-table-column>
				<c-table-column v-for="day in days" :key="day" :label="day" width="85" align-center>
					<template #default="{data}">
						<div class="cell-bg" :style="cellStyle(data.type, data.day_values[day])">{{fmtVal(data.type, data.day_values[day])}}</div>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
export default {
	name: 'AttendanceReport',

	data() {
		return {
			defaultSearchData: {
				month: this.currentMonth()
			},
			lastSearchData: {},
			days: []
		};
	},

	mounted() {
		this.searchHandle({ month: this.currentMonth() });
	},

	methods: {
		currentMonth() {
			const now = new Date();
			const pad = (n) => String(n).padStart(2, '0');
			return `${now.getFullYear()}-${pad(now.getMonth() + 1)}`;
		},

		searchHandle(data) {
			if (!data) {
				data = {};
			}
			this.lastSearchData = data;
			this.request({
				url: '/attendance/report/list',
				data: data,
				loading: true,
				success: (res) => {
					this.days = res.days || [];
					if (res.rows) {
						res.rows.forEach((item, index) => {
							if (index > 0 && res.rows[index - 1].user_id === item.user_id) {
								item.rowspan = 0;
							} else {
								let count = 1;
								for (let i = index + 1; i < res.rows.length; i++) {
									if (res.rows[i].user_id === item.user_id) {
										count++;
									} else {
										break;
									}
								}
								item.rowspan = count;
							}
						});
					}
					this.$nextTick(() => {
						this.$refs.list.setData(res.rows || []);
					});
				}
			});
		},

		fmtVal(typeId, val) {
			if (val === null || val === undefined || val === '') return '';

			const n = parseFloat(val);
            if(typeId === 3 && n <=0) return '';
			if (n === -1) return '缺';
			if (n === -2) return '休';
			return val;
		},

		cellStyle(typeId, val) {
			if (val === null || val === undefined || val === '') return {};
			const n = parseFloat(val);
			if (val === "缺") return {background: '#FEE2E2', color: '#B91C1C'};
			if (val === "休") return {background: '#EFF4F9', color: '#475569'};
			if (typeId === 1 && (n > 0 || val==="漏")) return {background: '#36C8B0', color: '#0F7687'};
			if (typeId === 2 && n > 0) return {background: '#74C856', color: '#047857'};
			if (typeId === 3 && n > 0) return {background: '#FFE3B3', color: '#B45309'};
			return {};
		},

		searchOutlet(keyword, resolve) {
			this.request({
				url: '/system/options',
				data: {
					options_code: 'AFTERSALE_OUTLET',
					keyword: keyword
				},
				success: data => {
					resolve(data);
				}
			});
		},

		exportHandle() {
			this.request({
				url: '/attendance/report/export/url',
				data: this.lastSearchData,
				loading: true,
				success: (data) => {
					this.download({
						fileName: data.filename,
						url: data.url,
						loading: {
							message: '数据文件生成中...'
						}
					});
				}
			});
		}
	}
};
</script>
<style lang="stylus" scoped>
.attendance-table
    >>> .c-table-main table tbody tr td
        padding 0.5px
        line-height 30px

.cell-bg
	min-height 100%
	margin -2px -3px
	padding 2px 3px
	box-sizing border-box
</style>
